(() => {
  const attributionKey = 'goat_sample_attribution_v1';
  const maxAttributionAge = 30 * 24 * 60 * 60 * 1000;
  const allowedToAttribute = (privacy, globalPrivacyControl) => {
    try {
      const consent = privacy?.currentVisitorConsent?.();
      return globalPrivacyControl !== true && consent?.marketing === 'yes' && consent?.analytics === 'yes'
        && privacy.marketingAllowed() === true && privacy.analyticsProcessingAllowed() === true
        && privacy.saleOfDataAllowed() === true;
    } catch (_) { return false; }
  };
  const captureAttribution = (privacy, storage, href, globalPrivacyControl, now = Date.now()) => {
    try {
      if (!allowedToAttribute(privacy, globalPrivacyControl)) {
        storage.removeItem(attributionKey);
        return null;
      }
      const url = new URL(href);
      const clickId = url.searchParams.get('gclid');
      let saved = JSON.parse(storage.getItem(attributionKey) || 'null');
      if (clickId && /^[A-Za-z0-9_.-]{10,512}$/.test(clickId) && saved?.gclid !== clickId) {
        saved = { gclid: clickId, observedAt: new Date(now).toISOString(),
          consentAt: new Date(now).toISOString(), consentId: String(privacy.consentId?.() || '').slice(0,120) };
        storage.setItem(attributionKey, JSON.stringify(saved));
      }
      const seen = Date.parse(saved?.observedAt || '');
      if (!saved || !Number.isFinite(seen) || seen > now || now - seen > maxAttributionAge) {
        storage.removeItem(attributionKey);
        return null;
      }
      return { ...saved, version: 1, marketing: 'yes', analytics: 'yes', saleOfDataAllowed: true,
        adUserData: 'GRANTED', adPersonalization: 'DENIED', checkedAt: new Date(now).toISOString(),
        source: 'shopify_customer_privacy_explicit' };
    } catch (_) { return null; }
  };
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { allowedToAttribute, captureAttribution };
    return;
  }
  const forms = document.querySelectorAll('.goat-home-sample__form, .goat-contact-page__form');

  if (!forms.length) {
    return;
  }

  const currentAttribution = () => {
    try {
      return captureAttribution(window.Shopify?.customerPrivacy,
        window.sessionStorage, window.location.href, navigator.globalPrivacyControl);
    } catch (_) { return null; }
  };
  const initializeAttribution = () => { currentAttribution(); };
  document.addEventListener('visitorConsentCollected', initializeAttribution);
  if (window.Shopify?.customerPrivacy) initializeAttribution();
  else {
    try {
      window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }],
        (error) => { if (!error) initializeAttribution(); });
    } catch (_) { /* Optional measurement must not interrupt sample ordering. */ }
  }

  const getField = (form, name) => form.querySelector(`[data-goat-sample-field="${name}"]`);
  const getValue = (form, name) => getField(form, name)?.value?.trim() || '';
  const isSampleRequest = (form) => {
    const requestType = getValue(form, 'requestType');

    return !requestType || requestType === 'sample';
  };
  const syncSampleFields = (form) => {
    const sampleRequest = isSampleRequest(form);

    form.dataset.goatSampleMode = sampleRequest ? 'sample' : 'message';
    form.querySelectorAll('[data-goat-sample-optional]').forEach((label) => {
      label.hidden = sampleRequest;
    });
    form.querySelectorAll('[data-goat-sample-required-group]').forEach((group) => {
      group.hidden = !sampleRequest;
    });
    form.querySelectorAll('[data-goat-sample-required]').forEach((field) => {
      field.required = sampleRequest;
      if (field.dataset.goatSampleField === 'useCase') field.disabled = !sampleRequest;
      field.setAttribute('aria-required', sampleRequest ? 'true' : 'false');
    });
    form.querySelectorAll('[data-goat-message-required]').forEach((field) => {
      field.required = !sampleRequest;
      field.setAttribute('aria-required', sampleRequest ? 'false' : 'true');
    });
    const otherUse = sampleRequest && getValue(form, 'useCase') === 'other';
    const notes = getField(form, 'notes');
    if (notes) {
      notes.required = otherUse || (!sampleRequest && notes.hasAttribute('data-goat-message-required'));
      notes.minLength = otherUse ? 12 : 0;
      notes.setAttribute('aria-required', String(notes.required));
      if (notes.dataset.goatDetailsPlaceholder) notes.placeholder = otherUse
        ? notes.dataset.goatOtherDetailsPlaceholder : notes.dataset.goatDetailsPlaceholder;
    }
    form.querySelectorAll('[data-goat-notes-optional]').forEach(label => { label.hidden = Boolean(notes?.required); });
  };

  const setStatus = (form, type, message) => {
    const wrapper = form.closest('[data-goat-sample-order-endpoint]');
    const success = wrapper?.querySelector('[data-goat-sample-order-success]');
    const error = wrapper?.querySelector('[data-goat-sample-order-error]');
    const submitButton = form.querySelector('[data-goat-sample-submit]');

    if (success) {
      success.hidden = type !== 'success';
      const messageNode = success.querySelector('[data-goat-sample-order-success-message]');

      if (messageNode && message) {
        messageNode.textContent = message;
      }
    }

    if (error) {
      error.hidden = type !== 'error';
      error.textContent = type === 'error' ? message : '';
    }

    if (submitButton) {
      submitButton.hidden = type === 'success';
    }
  };

  const getPayload = (form) => ({
    email: getValue(form, 'email'),
    name: getValue(form, 'name'),
    facility: getValue(form, 'facility'),
    useCase: getValue(form, 'useCase'),
    phone: getValue(form, 'phone'),
    address1: getValue(form, 'address1'),
    address2: getValue(form, 'address2'),
    city: getValue(form, 'city'),
    province: getValue(form, 'province'),
    zip: getValue(form, 'zip'),
    country: getValue(form, 'country'),
    notes: getValue(form, 'notes'),
    website: getValue(form, 'website'),
    fax: getValue(form, 'fax'),
    sourceUrl: window.location.origin + window.location.pathname + window.location.hash,
    adAttribution: JSON.stringify(currentAttribution())
  });

  const getEndpoint = (form) => form.closest('[data-goat-sample-order-endpoint]')?.dataset.goatSampleOrderEndpoint?.trim() || '';

  forms.forEach((form) => {
    if (form.dataset.goatSampleOrderReady === 'true') {
      return;
    }

    form.dataset.goatSampleOrderReady = 'true';
    let sending = false;
    let completed = false;
    let requestId = crypto.randomUUID();
    let tokenPromise;
    let tokenReadyAt = 0;
    const prepareToken = () => {
      const endpoint = getEndpoint(form);
      if (!endpoint || !isSampleRequest(form)) return Promise.resolve(null);
      if (!tokenPromise) {
        tokenPromise = fetch(`${endpoint.replace(/\/$/, '')}/challenge`, { mode: 'cors', cache: 'no-store', signal: AbortSignal.timeout(12000) })
          .then(async (response) => {
            if (response.status === 404) return null;
            const result = await response.json();
            if (!response.ok || !result.token) throw new Error(result.error || 'Please refresh the page and try again.');
            tokenReadyAt = Date.now() + 2100;
            return result.token;
          }).catch((error) => { tokenPromise = undefined; throw error; });
      }
      return tokenPromise;
    };
    form.addEventListener('focusin', () => { prepareToken().catch(() => {}); });
    const limits = { email: 254, name: 120, facility: 160, phone: 40, address1: 200, address2: 120, city: 100, province: 80, zip: 16, notes: 2000 };
    Object.entries(limits).forEach(([name, limit]) => {
      const field = getField(form, name);
      if (field) field.maxLength = limit;
    });
    syncSampleFields(form);
    getField(form, 'useCase')?.addEventListener('change', () => syncSampleFields(form));
    getField(form, 'requestType')?.addEventListener('change', () => {
      syncSampleFields(form);
      setStatus(form, '', '');
    });

    form.addEventListener('submit', async (event) => {
      const endpoint = getEndpoint(form);

      if (getValue(form, 'website') || getValue(form, 'fax')) {
        event.preventDefault();
        setStatus(form, 'error', 'We could not accept this request. Please call us if you need help.');
        return;
      }

      if (!endpoint || !isSampleRequest(form)) {
        return;
      }

      event.preventDefault();
      if (sending || completed) return;
      if (!form.reportValidity()) return;
      sending = true;
      form.setAttribute('aria-busy', 'true');
      setStatus(form, '', '');

      const submitButton = form.querySelector('[data-goat-sample-submit]');
      const previousLabel = submitButton?.textContent;

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Sending request...';
      }

      try {
        const formToken = await prepareToken();
        const waitMs = tokenReadyAt - Date.now();
        if (waitMs > 0) await new Promise(resolve => setTimeout(resolve, waitMs));
        const response = await fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ ...getPayload(form), requestId, formToken: formToken || '' }),
          signal: AbortSignal.timeout(30000)
        });
        const result = await response.json().catch(() => ({}));

        if (!response.ok || !result.ok) {
          if (response.status === 403) tokenPromise = undefined;
          throw new Error(result.error || 'We could not send the sample request.');
        }

        if (!/^gid:\/\/shopify\/Order\/[1-9]\d*$/.test(String(result.orderId || ''))) {
          throw new Error('We could not confirm your sample order. Please check your email or call us before submitting again.');
        }

        completed = true;
        form.reset();
        syncSampleFields(form);
        setStatus(form, 'success', 'Thanks. Your sample request is in our fulfillment queue.');
        if (!result.duplicate) document.dispatchEvent(new CustomEvent('goat:sample-request-success', {
          detail: {
            order_id: result.orderId,
            order_name: result.orderName,
            form_location: form.classList.contains('goat-contact-page__form') ? 'contact_sample' : 'home_sample'
          }
        }));
      } catch (error) {
        setStatus(form, 'error', error?.name === 'TimeoutError' ? 'Your request is taking longer than expected. Please check your email or call us before submitting again.' : error instanceof Error ? error.message : 'We could not send the sample request.');
      } finally {
        sending = false;
        form.removeAttribute('aria-busy');
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = previousLabel || 'Send sample request';
        }
      }
    });
  });
})();
